export const resetState = ({ commit }) => {
  commit("RESET_STATE");
};

export const generateTypingContent = ({ commit }, { lesson, strChar }) => {
  commit("SET_TYPING_CONTENT", { lesson, strChar });
};
